import React from "react";
import { Button, TextareaAutosize, TextField } from "@material-ui/core";
import { Formik } from "formik";
import { Select } from "antd";
import convertPersianToEnglishNumber from "../../utils/convert-persian-to-english-number";
import {
  getAllTownshipsGroup,
  getTravelType,
  setCharter,
} from "../Homepage/pages/widgets/components/cruds";
import jalaali from "jalaali-js";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import ReactLoading from "react-loading";
import { toast, ToastContainer } from "react-toastify";
import * as Scroll from "react-scroll";

const { Option, OptGroup } = Select;

const Charter = (props) => {
  const [towns, setTowns] = React.useState(null);
  const [sourceValue, setSourceValue] = React.useState(null);
  const [destValue, setDestValue] = React.useState(null);
  const [selectedDay, setSelectedDay] = React.useState(null);
  const [backDay, setBackDay] = React.useState(null);
  const [travelTypes, setTravelTypes] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    let scroll = Scroll.animateScroll;
    getAllTownshipsGroup().then((res) => {
      setTowns(res.data.data);
    });

    getTravelType().then((res) => {
      setTravelTypes(res.data.data);
    });

    scroll.scrollToTop();
  }, []);

  const renderCustomInput = ({ ref }) => {
    return (
      <>
        <input
          readOnly
          placeholder="تاریخ را انتخاب کنید"
          value={
            selectedDay
              ? `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`
              : ""
          }
          ref={ref}
          style={{
            textAlign: "right",
            padding: "1.9rem 1rem",
            fontSize: "1rem",
            border: "1px solid #b5b5c3",
            width: "100%",
            borderRadius: "12px",
            color: "currentColor",
            height: "48px",
            outline: "none",
            backgroundColor: "white",
          }}
          className="my-custom-input-class" // a styling class
        />
      </>
    );
  };

  const renderBackCustomInput = ({ ref }) => {
    return (
      <>
        <input
          readOnly
          placeholder="تاریخ را انتخاب کنید"
          value={
            backDay ? `${backDay.year}/${backDay.month}/${backDay.day}` : ""
          }
          ref={ref}
          style={{
            textAlign: "right",
            padding: "1.9rem 1rem",
            fontSize: "1rem",
            border: "1px solid #b5b5c3",
            width: "100%",
            borderRadius: "12px",
            color: "currentColor",
            height: "48px",
            outline: "none",
            backgroundColor: "white",
          }}
          className="my-custom-input-class" // a styling class
        />
      </>
    );
  };

  return (
    <div className="row">
      <ToastContainer rtl={true} />
      <div className="w-100 p-0" id="contact-div">
        <div className="container w-100 h-100 d-flex align-items-center">
          <h1 className="text-white" >
            <b>سرویس دربستی  اتوبوس 
              
            </b>
          </h1>
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div
          className="container pt-5 bg-white landings-container"
        >
          <h2
            className="p-4 col-6 col-md-3"
            style={{
              borderBottom: "2.3px solid #6dd06d",
              whiteSpace: "nowrap",
              fontSize:"21px",
            }}
          >
            <b>سرویس دربستی اتوبوس</b>
          </h2>
          <div className="mt-10 mb-20">
            <h3 style={{ lineHeight: "30px" }}>
              برای سفرهای طولانی ,دسته جمعی ,برگزاری تورهای گروهی ,کاری ...
              سرویس دربستی ایباس از ابتدای سفر تا پایان سفر همراه شما خواهد بود.
              پس از وارد کردن اطلاعات خود ,درخواست رزروسفر دربستی را ثبت
              بفرمایید ,تیم پشتیبانی سفرهای دربستی ایباس پس از بررسی درخواست
              سفر درسریع ترین زمان ممکن با شما تماس خواهد گرفت.
            </h3>
            <Formik
              enableReinitialize
              initialValues={{}}
              onSubmit={(values) => {
                const keys = Object.keys(values);
               
                const depDate = jalaali
                  .jalaaliToDateObject(
                    selectedDay?.year,
                    selectedDay?.month,
                    selectedDay?.day
                  )
                  .toLocaleDateString()
                  .split("/");
                
                const backDate = jalaali
                  .jalaaliToDateObject(
                    backDay?.year,
                    backDay?.month,
                    backDay?.day
                  )
                  .toLocaleDateString()
                  .split("/");

                keys.map((el) => {
                  if (!values[el]) {
                    delete values[el];
                  } else {
                  }
                });
                setIsLoading(true);
                setCharter(values)
                  .then((res) => {
                    setIsLoading(false);
                    toast.success(
                      "درخواست شما ایجاد شد و بزودی با شما تماس خواهد گرفته شد"
                    );
                  })
                  .catch((err) => {
                    toast.error("مشکلی در ارتباط با سرور بوجود آمد");
                    setIsLoading(false);
                  });
              }}
            >
              {({
                handleSubmit,
                setFieldValue,
                errors,
                touched,
                isValid,
                values,
              }) => {
                return (
                  <div className="row  my-7">
                    <div
                      className="col-12 my-3  col-md-6 col-lg-3"
                      style={{ height: "4rem" }}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        style={{ borderRadius: "13px" }}
                        className="w-100 h-100"
                        onChange={(e, a) => {
                          setFieldValue("sourceTownshipId", a.id);
                          setSourceValue(e);
                        }}
                        // onChange={handleSearch}
                        value={sourceValue}
                        placeholder={
                          <span
                            className="d-flex align-items-center"
                            style={{ gap: "5px" }}
                          >
                            <span className="mx-auto my-auto text-muted">مبدا</span>
                          </span>
                        }
                      >
                        {towns
                          ? towns.map((province) => {
                              return (
                                <OptGroup label={province.title}>
                                  {province.Townships.map((towns) => {
                                    return (
                                      <Option value={towns.code} id={towns.id}>
                                        <i
                                          className="fa fa-map-marker"
                                          style={{
                                            fontSize: 15,
                                            color: "#6dd06d",
                                          }}
                                        ></i>{" "}
                                        {towns.title}
                                      </Option>
                                    );
                                  })}
                                </OptGroup>
                              );
                            })
                          : []}
                      </Select>
                    </div>
                    <div
                      className="col-12 my-3  col-md-6 col-lg-3"
                      style={{ height: "4rem" }}
                    >
                      {" "}
                      <Select
                        showSearch
                        optionFilterProp="children"
                        style={{ borderRadius: "13px" }}
                        className="w-100 h-100"
                        onChange={(e, a) => {
                          setFieldValue("destTownshipId", a.id);
                          setDestValue(e);
                        }}
                        // onChange={handleSearch}
                        value={destValue}
                        placeholder={
                          <span
                            className="d-flex align-items-center"
                            style={{ gap: "5px" }}
                          >
                            <span className="mx-auto my-auto text-muted">مفصد</span>
                          </span>
                        }
                      >
                        {towns
                          ? towns.map((province) => {
                              return (
                                <OptGroup label={province.title}>
                                  {province.Townships.map((towns) => {
                                    return (
                                      <Option value={towns.code} id={towns.id}>
                                        <i
                                          className="fa fa-map-marker"
                                          style={{
                                            fontSize: 15,
                                            color: "#6dd06d",
                                          }}
                                        ></i>{" "}
                                        {towns.title}
                                      </Option>
                                    );
                                  })}
                                </OptGroup>
                              );
                            })
                          : []}
                      </Select>
                    </div>
                    <div
                      className="col-12 my-3  col-md-6 col-lg-3"
                      style={{ height: "4rem" }}
                    >
                      {" "}
                      <DatePicker
                        value={selectedDay}
                        calendarPopperPosition="bottom"
                        onChange={setSelectedDay}
                        name="departureDate"
                        shouldHighlightWeekends
                        renderInput={renderCustomInput}
                        minimumDate={utils("fa").getToday()}
                        style={{ height: "45px", width: "100%" }}
                        locale="fa"
                      />
                    </div>
                    <div
                      className="col-12 my-3  col-md-6 col-lg-3"
                      style={{ height: "4rem" }}
                    >
                      {" "}
                      <DatePicker
                        value={backDay}
                        calendarPopperPosition="bottom"
                        onChange={setBackDay}
                        name="departureDate"
                        shouldHighlightWeekends
                        renderInput={renderBackCustomInput}
                        minimumDate={utils("fa").getToday()}
                        style={{ height: "45px", width: "100%" }}
                        locale="fa"
                      />
                    </div>
                    <div
                      className="col-12 my-3  col-md-6 col-lg-3"
                      style={{ height: "4rem" }}
                    >
                      {" "}
                      <Select
                        showSearch
                        optionFilterProp="children"
                        style={{ borderRadius: "13px" }}
                        className="w-100 h-100"
                        placeholder="توع سفر"
                        onChange={(e) => {
                          setFieldValue("travelTypeId", e);
                        }}
                      >
                        {travelTypes
                          ? travelTypes.map((el) => {
                              return <Option value={el.id}>{el.title}</Option>;
                            })
                          : null}
                      </Select>
                    </div>
                    <div
                      className="col-12 my-3  col-md-6 col-lg-3"
                      style={{ height: "4rem" }}
                    >
                      {" "}
                      <TextField
                        className="w-100 h-100"
                        variant="outlined"
                        placeholder="نام"
                        onChange={(e) => {
                          setFieldValue("firstName", e.target.value);
                        }}
                      />
                    </div>
                    <div
                      className="col-12 my-3  col-md-6 col-lg-3"
                      style={{ height: "4rem" }}
                    >
                      {" "}
                      <TextField
                        className="w-100 h-100"
                        variant="outlined"
                        placeholder="نام خانوادگی"
                        onChange={(e) => {
                          setFieldValue("lastName", e.target.value);
                        }}
                      />
                    </div>
                    <div
                      className="col-12 my-3  col-md-6 col-lg-3"
                      style={{ height: "4rem" }}
                    >
                      {" "}
                      <TextField
                        className="w-100 h-100"
                        variant="outlined"
                        placeholder="شماره تماس"
                        onChange={(e) => {
                          setFieldValue("phone", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-12 my-3 " style={{ height: "12rem" }}>
                      <TextareaAutosize
                        minRows="6"
                        placeholder="توصیحات(در صورت لزوم)"
                        className="w-100 h-100 p-3"
                        style={{ borderRadius: "10px" }}
                        onChange={(e) =>
                          setFieldValue("description", e.target.value)
                        }
                      />
                    </div>
                    <div className="d-flex flex-wrap container justify-content-end">
                      <Button
                        variant="outlined"
                        className="col-12 col-md-3 w-100"
                        style={{
                          height: "3rem",
                          backgroundColor: "#6dd06d",
                          borderRadius: "12px",
                        }}
                        onClick={() => handleSubmit()}
                      >
                        {isLoading ? (
                          <ReactLoading
                            type={"spin"}
                            color={"white"}
                            height={"12%"}
                            width={"12%"}
                          />
                        ) : (
                          <span className="mx-auto my-auto text-white" style={{}} >ثبت</span>
                        )}
                      </Button>
                    </div>
                  </div>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Charter;
